import './index.scss'
$("header .nav ul li").eq(1).addClass("active"); 